<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const {toplineText, toplineType, headlineText, headlineType, Boxes, mainText } = props.content.data

</script>
<template>
  <section class="prose-p:text-sm prose-h3:mb-7 prose-h6:text-base prose-h6:mb-7 text-sm py-5">

    <div class="mb-10">
      <div class="container px-0 xl:px-5">
        <SharedTopline :headline="toplineText" :headlineType="toplineType"></SharedTopline>
        <SharedHeadline :headline="headlineText" :headlineType="headlineType"></SharedHeadline>
      </div>
    </div>

    <div class="container px-0 xl:px-5">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12 mb-7">
        <template v-for="(box, index) in Boxes" :key="index">
        <div>
          <div v-if="box.boxImage && box.boxImage.media" class="eql mb-7">
            <NuxtImg v-if="box.boxImage && box.boxImage.media" :src="box.boxImage.media.url" alt="" width="80"/>
          </div>
          <h6 v-html="box.boxTitle"></h6>
          <div class="mb-4" v-html="box.boxText"></div>
        </div>
        </template>
      </div>
    </div>
  </section>
</template>
